import React, { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";
import { api } from "../lib/api";

export const PublicLayout = () => {
  const [content, setContent] = useState(null);

  useEffect(() => {
    api.get("/content").then((r) => setContent(r.data)).catch(() => {});
  }, []);

  return (
    <div className="min-h-screen bg-[#0B1020] text-white">
      <Navbar logoUrl={content?.logo_url} />
      <main>
        <Outlet context={{ content }} />
      </main>
      <Footer contact={content?.contact} logoUrl={content?.logo_url} socialLinks={content?.social_links} />
    </div>
  );
};

export default PublicLayout;
